import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

export type EquipmentsFromClientProps = {
    clientErpId?: string | null;
    clientName?: string | null;
};

export default function EquipmentsFromClient({ clientErpId, clientName }: EquipmentsFromClientProps) {
    const MainContent = useDynamicComponent("EquipmentsFromClient", { clientErpId, clientName });
    return (
        <div>
            {MainContent}
        </div>
    );
}